<template>
  <div class="wrapper">
    <div class="createTasteTeam">
      <Step0Left
        v-if="current === STEPS.STEP0"
        class="w-[40%] h-full step-0-left"
      />
      <Step1Left v-if="current === STEPS.STEP1" class="w-[40%] h-full" />
      <div class="flex-grow flex flex-col items-center relative">
        <Steps class="mt-[92px] mb-[82px] steps" :current="current" />
        <Step0Content v-if="current === STEPS.STEP0" @next="nextStep" />
        <Step1Content v-if="current === STEPS.STEP1" @login="onLogin" />
        <Step2Content v-if="current === STEPS.STEP2" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Step1Left from './components/taste/step1/left.vue'
import Step0Content from './components/taste/step0/content.vue'
import Step1Content from './components/taste/step1/content.vue'
import Step2Content from './components/taste/step2/content.vue'

import Steps from './components/taste/steps/index.vue'
import Step0Left from '~/pages/login/ContentLeft.vue'
import { STEPS, TEAM_TASTE_PAY_YANBI_KEY } from '~/constants/teamCreate'
import type { LoginInfo, UserInfo } from '~/api/interface'
import { getUserToken, loginForWeb } from '~/api'
import { BROADCAST_KEY, COOKIE_KEY } from '~/constants/config'

const route = useRoute()
const router = useRouter()
const session = useSession()
const { setSession } = useChangeUser()

const current = ref<STEPS>(Number(route.query.step) || STEPS.STEP0)

// const userInfo = useClient(() => sessionGetItem(TEAM_TASTE_PAY_YANBI_KEY))
const userInfo = useUserInfo()

watch(
  () => route.query.step,
  (step) => {
    current.value = Number(step) || STEPS.STEP0
  },
  { immediate: true }
)

watch(
  () => session.value,
  (user) => {
    if (!user?.user_id && current.value !== STEPS.STEP0) {
      router.replace({
        query: { step: STEPS.STEP0 },
        name: route.name as string,
      })
    }
  },
  { immediate: true }
)

function nextStep() {
  router.push({
    query: { step: current.value + 1 },
    name: route.name as string,
  })
}

function updateCustomSetting(userInfo: any) {
  CustomSettingApp.initAvatar(userInfo.logo_url, userInfo.default_logo_url)
  CustomSettingApp.initLogo(
    userInfo.platform_logo_url,
    userInfo.default_platform_logo_url
  )
}

async function onLogin(info: UserInfo) {
  sessionSetItem(TEAM_TASTE_PAY_YANBI_KEY, info)
  userInfo.value = info
  const { data } = await getUserToken(info.user_id) // 获取LoginInfo
  const account = data?.[0] as LoginInfo

  sensorsLogin(Number(account.user_id))

  await setSession(account) // 更新当前账户

  updateCustomSetting(account) // 更新头像和logo

  // emitBroadcast(COOKIE_KEY.USER_TOKEN, {
  //   cookieValue: JSON.parse(JSON.stringify(session.value)),
  // })
  emitBroadcast(BROADCAST_KEY.REFRESH, { tabId: TAB_ID })

  nextStep()
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  width: 100vw;
  overflow: auto;
  // padding-bottom: 100px;
  background: var(--create-wrapper-bg);
}

.step-0-left {
  transform: translateX(100px);
}

.createTasteTeam {
  display: flex;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  padding-bottom: 100px;
  align-items: center;

  background: var(--create-wrapper-bg);
  .steps {
    width: min(80%, 800px);
  }
}
</style>
